import React, { useRef, useEffect, useState } from "react";
import LabelContainer from "../LabelContainer";

const AutocompleteInput = ({
  k = -1,
  autoFocus,
  autocomplete = "on",
  inputStyle = {},
  inputClassName = "",
  disabled = false,
  id = null,
  value,
  change = () => {},
  placeholder = "",
  datas = [],
  autoCompleteDisplayIndex = false,
  dataIndex = "id",
  dataLabel = "name",
  dataLabel2 = false,
  dataLabel3 = false,
  dataLabelRight = false,
  dataLabelBtn1 = false,
  dataLabelBtn2 = false,
  hideAutocompleteOnFocusOut = true,
  absoluteAutocomplete = false, //buggé
  isLoading = false,
  noResults = false,
  autoCompleteHasApiDatas = false,
  ...props
}) => {
  const inputRef = useRef(null);
  const fieldRef = useRef(null);
  const containerRef = useRef(null);
  const name = props.name;
  const [autoCompleteEntrySelected, setAutoCompleteEntrySelected] =
    useState(false);
  const [searchStr, setSearchStr] = useState("");
  const [acInput, setAcInput] = useState(value);
  const [acResults, setAcResults] = useState([]);
  const [formatedValue, setFormatedValue] = useState("");
  var selector = k != -1 ? name + "-ac" + k : id ? id : name;

  const valueChange = (e, value) => {
    var filteredValue = value;

    setAutoCompleteEntrySelected(value == "" ? false : true);
    let changeEvent = {
      target: {
        name: props.name,
        value: filteredValue,
        k: k,
      },
    };

    change(changeEvent);
    hideAutocomplete();
  };

  useEffect(() => {
    if (value && value != "") setAutoCompleteEntrySelected(true);
    else setAutoCompleteEntrySelected(false);
  }, [value]);

  useEffect(() => {
    seekAutocomplete();
    if (searchStr.length > 0) showAutocomplete();
  }, [searchStr]);

  const onFocus = () => {
    showAutocomplete();
  };

  useEffect(() => {
    seekAutocomplete();
    //showAutocomplete();
  }, [datas]);

  function seekAutocomplete() {
    var acs = [];
    const searchStrLower = searchStr.toLowerCase();

    datas.forEach((d) => {
      // Check main fields as before
      if (
        autoCompleteHasApiDatas ||
        (d[dataLabel] && d[dataLabel].toLowerCase().includes(searchStrLower)) ||
        (d[dataLabel2] &&
          d[dataLabel2].toLowerCase().includes(searchStrLower)) ||
        (d[dataLabel3] && d[dataLabel3].toLowerCase().includes(searchStrLower))
      ) {
        acs.push(d);
        return;
      }

      // Check alias field if it exists and is not null
      if (d.alias && d.alias !== "null" && d.alias !== '[""]') {
        try {
          const aliases = JSON.parse(d.alias);
          if (
            Array.isArray(aliases) &&
            aliases.some((alias) =>
              alias.toLowerCase().includes(searchStrLower)
            )
          ) {
            acs.push(d);
          }
        } catch (e) {
          console.warn("Failed to parse alias for item:", d.name);
        }
      }
    });

    setAcResults(acs);
  }

  function hideAutocomplete() {
    inputRef.current.style.display = "none";
  }
  function showAutocomplete() {
    inputRef.current.style.display = "block";
  }
  function getCompositeData(obj, key) {
    var comp = key ? key.split(".") : [""];
    if (comp.length > 1) {
      return obj[comp[0]][comp[1]];
    }

    return obj[comp[0]];
  }

  const selectedEntry = datas.find((d) => d[dataIndex] == value);

  return (
    <LabelContainer {...props} value={value}>
      <div className="w-100">
        <div className=" w-100" ref={containerRef}>
          <input
            ref={fieldRef}
            onFocus={onFocus}
            className={"form-control " + inputClassName}
            disabled={disabled ? "disabled" : false}
            autoFocus={autoFocus}
            value={searchStr}
            name={name}
            id={selector}
            onChange={(e) => setSearchStr(e.target.value)}
            placeholder={placeholder}
            autoComplete={autocomplete}
          />
          <button
            className={"btn text-dark position-absolute p-0 bg-white"}
            onClick={(e) => {
              fieldRef.current.focus();
              setSearchStr("");
              valueChange(e, "");
            }}
            style={{
              opacity: searchStr != "" || value != "" ? "1" : "0",

              width: 30,
              height: 33,
              right: 10,
              minHeight: "auto",
              top: 25,
              transform: "translateY(-50%)",
              zIndex: "99",
            }}
          >
            <i className="fa fa-times" />
          </button>
        </div>
        {autoCompleteEntrySelected && (
          <button
            id={"btn-over-" + selector}
            className="btn  text-left position-absolute w-100  border"
            style={{
              padding: "0 10px",
              color: "black",
              borderRadius: 3,
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              minHeight: 0,
              bottom: 34,
              cursor: "pointer",
              position: "relative",
              left: 0,
              height: 48,
              background: "#fbfafa",
            }}
            onClick={(e) => {
              setAutoCompleteEntrySelected(false);
              valueChange(e, "");
              document.querySelector("#btn-over-" + selector).style.display =
                "none";
              fieldRef.current.focus();
            }}
          >
            {autoCompleteDisplayIndex && selectedEntry ? (
              <>
                <span className="mr-2">
                  {selectedEntry[autoCompleteDisplayIndex]}
                </span>
                {/* {dataLabel2 && (
                <> {getCompositeData(selectedEntry, dataLabel2)} </>
              )} */}
                <span className="ml-2" style={{ fontSize: 12 }}>
                  {getCompositeData(selectedEntry, dataLabelBtn1)}{" "}
                  {getCompositeData(selectedEntry, dataLabelBtn2)}
                </span>
              </>
            ) : value ? (
              value
            ) : (
              ""
            )}
          </button>
        )}

        {noResults && (
          <>
            <div
              className="w-100 position-relative"
              style={{
                margin: "60px 0 30px 0",
                left: -60,
              }}
            >
              Aucun résultat trouvé
            </div>
            <button
              className="btn btn-default"
              onClick={(e) => {
                valueChange(e, "");
                var bid = selector;
                document.querySelector("#" + bid).focus();
              }}
            >
              Modifier ma recherche
            </button>
          </>
        )}
        <div
          ref={inputRef}
          className={
            "ac-results my-2 p-2 border rounded  fast " +
            (absoluteAutocomplete ? " position-absolute " : " ")
          }
          id={"acres" + selector}
          style={{
            top: 52,
            left: 0,
            padding: 0,
            width: "100%",
            zIndex: "99999",
            display: "none",
            borderRadius: window.borderRadius,
            // boxShadow: "0px 2px 8px -5px black",
            overflowY: "scroll",
            overflowX: "hidden",
            height: autoCompleteEntrySelected ? 0 : 200,
            // position: "absolute",
            background: "white",
            visibility: autoCompleteEntrySelected ? "hidden" : "visible",
          }}
        >
          {acResults.length == 0 && (
            <div
              className="text-dark d-flex align-items-center rounded flex-row justify-content-between"
              style={{ fontWeight: "normal" }}
            >
              Aucun résultat trouvé, veuillez modifier votre recherche
            </div>
          )}
          {acResults.map((a, ak) => {
            if (ak >= 30) return null;
            return (
              <div
                className="ac-res text-dark d-flex align-items-center rounded flex-row justify-content-between"
                style={{
                  padding: autoCompleteEntrySelected ? 0 : "5.5px 9px",
                  height: autoCompleteEntrySelected ? "0px" : "auto",
                  opacity: autoCompleteEntrySelected ? "0" : "1",

                  width: "100%",
                  cursor: "pointer",
                  animationDelay: ak * 80 + "ms",
                  overflow: "hidden",
                  transition: "400ms",
                }}
                onClick={(e) => valueChange(e, a[dataIndex] + "")}
                key={"acres" + ak + "" + k}
              >
                <div className="d-flex flex-column" style={{ fontSize: 14 }}>
                  <div>
                    {getCompositeData(a, dataLabel)}{" "}
                    {/* {dataLabel2 && " " + getCompositeData(a, dataLabel2)} */}
                    {dataLabel3 && " " + getCompositeData(a, dataLabel3)}
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                    }}
                  >
                    {dataLabelBtn1 && " " + getCompositeData(a, dataLabelBtn1)}
                    {dataLabelBtn2 && " " + getCompositeData(a, dataLabelBtn2)}
                  </div>
                </div>
                <div
                  style={{
                    fontSize: 14,
                  }}
                >
                  {dataLabelRight ? getCompositeData(a, dataLabelRight) : ""}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </LabelContainer>
  );
};

export default AutocompleteInput;
